import script from "./SidePanelReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelReviews.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelReviews.vue?vue&type=style&index=0&id=5532e772&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5532e772"]])

export default __exports__